// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OGKT","right":"styles_right__3MS5J"};